import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import {
  GenericLinkDirective,
  GenericRichTextDirective,
} from '@core/jss-utils';
import { AnalyticsDirectivesModule } from '@analytics/events';
import { AutomationIdDirective } from '@innogy/utils-automation-id';
import {
  NgbAccordionModule,
  NgbAlertModule,
  NgbPopoverModule,
  NgbRatingModule,
} from '@ng-bootstrap/ng-bootstrap';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { JssModule } from '@sitecore-jss/sitecore-jss-angular';
import { CrntIconButton } from '@essent/current-web-angular';
import {
  CSCaptureDirective,
  CSMaskDirective,
} from '@legacy/utils-contentsquare';

import { AccordionComponent } from './accordion/accordion.component';
import { AddressComponent } from './address/address.component';
import { AsyncButtonComponent } from './async-button/async-button.component';
import { CalculateCardComponent } from './calculate-card/calculate-card.component';
import { ChangeButtonComponent } from './change-button/change-button.component';
import { ChecklistItemComponent } from './checklist-item/checklist-item.component';
import { CollapsableInfoBlockComponent } from './collapsable-info-block/collapsable-info-block.component';
import { ContentCardComponent } from './content-card/content-card.component';
import { ErrorCardComponent } from './error-card/error-card.component';
import { ErrorMessageComponent } from './error-message/error-message.component';
import { FilterComponent } from './filter/filter.component';
import { IconCardButtonComponent } from './icon-card-button/icon-card-button.component';
import { ImageCardButtonComponent } from './image-card-button/image-card-button.component';
import { ImageComponent } from './image/image.component';
import { InfoCardComponent } from './info-card/info-card.component';
import { InformationBlockComponent } from './information-block/information-block.component';
import { ListComponent } from './list/list.component';
import { ModalPageHeaderComponent } from './modal-page-header/modal-page-header.component';
import { MoreInfoButtonComponent } from './more-info-button/more-info-button.component';
import { SegmentedControlComponent } from './segmented-control/segmented-control.component';
import { SelfServiceCardComponent } from './selfservice-card/selfservice-card.component';
import { SuccessPageComponent } from './success-page/success-page.component';
import { ServerErrorComponent } from './technical-issues/server-error.component';
import { ToolTipComponent } from './tooltip/tooltip.component';
import { RichTextWrapperComponent } from './rich-text-wrapper/rich-text-wrapper.component';

/**
 * @deprecated Please import the components you need from this module directly
 */
@NgModule({
  imports: [
    CommonModule,
    AnalyticsDirectivesModule,
    FontAwesomeModule,
    NgbAccordionModule,
    NgbPopoverModule,
    NgbAlertModule,
    NgbRatingModule,
    JssModule,
    TranslatePipe,
    TranslateDirective,
    CSCaptureDirective,
    CSMaskDirective,
    CrntIconButton,
    AccordionComponent,
    ToolTipComponent,
    ServerErrorComponent,
    SuccessPageComponent,
    ModalPageHeaderComponent,
    ListComponent,
    ContentCardComponent,
    ErrorCardComponent,
    ErrorMessageComponent,
    ChangeButtonComponent,
    FilterComponent,
    InfoCardComponent,
    AddressComponent,
    ChecklistItemComponent,
    IconCardButtonComponent,
    ImageCardButtonComponent,
    ImageComponent,
    InformationBlockComponent,
    MoreInfoButtonComponent,
    AsyncButtonComponent,
    CalculateCardComponent,
    CollapsableInfoBlockComponent,
    SelfServiceCardComponent,
    SegmentedControlComponent,
    // TechDebt: Here for backwards compatibility, preferably these should be imported directly (ATL-2284 / ATL-2857)
    AutomationIdDirective,
    GenericRichTextDirective,
    GenericLinkDirective,
    RichTextWrapperComponent,
  ],
  exports: [
    AccordionComponent,
    ToolTipComponent,
    ServerErrorComponent,
    SuccessPageComponent,
    ModalPageHeaderComponent,
    ListComponent,
    ContentCardComponent,
    ErrorCardComponent,
    ErrorMessageComponent,
    ChangeButtonComponent,
    FilterComponent,
    InfoCardComponent,
    AddressComponent,
    ChecklistItemComponent,
    IconCardButtonComponent,
    ImageCardButtonComponent,
    ImageComponent,
    InformationBlockComponent,
    MoreInfoButtonComponent,
    AsyncButtonComponent,
    CalculateCardComponent,
    CollapsableInfoBlockComponent,
    SelfServiceCardComponent,
    SegmentedControlComponent,
    // TechDebt: Here for backwards compatibility, preferably these should be imported directly (ATL-2284 / ATL-2857)
    AutomationIdDirective,
    GenericRichTextDirective,
    GenericLinkDirective,
    RichTextWrapperComponent,
  ],
})
export class CommonUiUtilityComponentsModule {}
